import { Directive, ElementRef, Input, signal, TemplateRef, ViewContainerRef, WritableSignal } from '@angular/core';
import { FeatureFlagsService } from '@core/services/feature-flags.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[featureFlag]',
})
export class FeatureFlagDirective {
  hasView: WritableSignal<boolean> = signal(false);


  constructor(private element: ElementRef,
              private viewContainer: ViewContainerRef,
              private templateRef: TemplateRef<string>,
              private featureFlagService: FeatureFlagsService) {
  }

  @Input() set featureFlag(feature: string) {
    if (this.featureFlagService.isFeatureEnabled(feature) && !this.hasView()) {
      this.hasView.set(true);
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.hasView.set(false);
    this.viewContainer.clear();
  }
}
